import getStore from 'services/getStore';
import { setActiveTopicAction } from "actions/setActiveTopicAction";

export default id => {
  getStore().dispatch(setActiveTopicAction(id));
};
